import { ShoppingBag } from 'lucide-react';

interface IconProps {
  className?: string;
  size?: number;
  strokeWidth?: number;
}

export function ShoppingBagIcon({ className = '', size = 24, strokeWidth = 1.5 }: IconProps) {
  return (
    <ShoppingBag
      width={size}
      height={size}
      strokeWidth={strokeWidth}
      className={className}
    />
  );
}
